module.exports = __webpack_public_path__ + "static/divider6-032902ebae2fd9b122cf6c0b7852cc31.svg";